import React, { PropsWithChildren } from 'react';
import { TabPanelProps } from '../TabbedListContent.interfaces';

const TabPanel = ({ children, value, index, ...restProps }: PropsWithChildren<TabPanelProps>) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...restProps}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
};

export default TabPanel;
